/**
 *  marsco开户没有针对年龄限制开户类型、并且默认为MARGIN帐户类型
 */
import { $Formutil, connect, RadioGroup } from 'react-bootstrap-formutil';
import BorderRadio from 'components/BorderRadio';
import FormGroup from 'components/FormGroup';
import { AccountCapabilitiesEnum, CategoryEnum, CustomerInfoKeyType } from 'types/customer';
import { IS_TIGER_SELF } from 'utils/constants';
import cashDarkImg from './images/cash-dark.png';
import cashDefaultImg from './images/cash.png';
import marginDarkImg from './images/margin-dark.png';
import marginDefaultImg from './images/margin.png';

export interface AccountCapabilityFormutil {
    account_capabilities: AccountCapabilitiesEnum;
}

interface AccountCapabilityProps {
    $formutil: $Formutil<AccountCapabilityFormutil>;
    category: CategoryEnum;
    disabled?: boolean;
}

const cashImg = !IS_TIGER_SELF ? cashDarkImg : cashDefaultImg;
const marginImg = !IS_TIGER_SELF ? marginDarkImg : marginDefaultImg;

export const defaultFieldsOfAccountCapability: CustomerInfoKeyType[] = ['account_capabilities'];

const AccountCapability: React.FC<AccountCapabilityProps> = props => {
    const { $formutil, category, disabled } = props;
    const { account_capabilities } = $formutil.$params;
    const disallowMargin = category === CategoryEnum.IRA;

    return (
        <div>
            {/* 小标题放在组件内部，外面一般是有页面大标题 */}
            <h4 className="mt-4 mb-3">{__('Account Type')}</h4>
            <FormGroup<AccountCapabilitiesEnum>
                name="account_capabilities"
                className="mb-2"
                $defaultValue={disallowMargin ? AccountCapabilitiesEnum.CASH : AccountCapabilitiesEnum.MARGIN}
                checker={value => !!value || __('Please select your account type')}>
                <RadioGroup>
                    {/* RadioGroup的子元素类型不能设置成null或者falsy, 否则会有类型报错 */}
                    {disallowMargin ? (
                        <></>
                    ) : (
                        <BorderRadio
                            value={AccountCapabilitiesEnum.MARGIN}
                            id="account_capabilities_1"
                            active={account_capabilities === AccountCapabilitiesEnum.MARGIN}
                            disabled={disabled}
                            checkedType="checkbox"
                            labelOptions={{
                                img: marginImg,
                                title: __('Margin Account'),
                                description: __(
                                    '"Margin Account" is a type of brokerage account in which your broker-dealer lends you cash, using the account as collateral, to purchase securities.'
                                )
                            }}
                        />
                    )}
                    <BorderRadio
                        value={AccountCapabilitiesEnum.CASH}
                        id="account_capabilities_2"
                        active={account_capabilities === AccountCapabilitiesEnum.CASH}
                        disabled={disabled}
                        checkedType="checkbox"
                        labelOptions={{
                            img: cashImg,
                            title: __('Cash Account'),
                            description: __(
                                '"Cash account" is a type of brokerage account in which you must pay the full amount for securities purchased. In a cash account, you can not borrow funds from your broker-dealer to pay for transactions in the account.'
                            )
                        }}
                    />
                </RadioGroup>
            </FormGroup>
        </div>
    );
};

export default connect(AccountCapability);
